export enum LoanStatus {
    Draft = 'Draft',
    Active = 'Active',
    Priced = 'Priced',
    Cancelled = 'Cancelled',
}
